// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XOhk","newExpiryDate":"styles_newExpiryDate__2e_z7","footer":"styles_footer__1NX6l"};